import { Fragment } from "react";
import { Box, Button, Grid, useTheme, useMediaQuery } from '@mui/material';
import { Typography } from '@mui/material';
import React from 'react';
import styles from "./scratchClubHeader.module.css";
import {useLocation, useNavigate} from "react-router";
import BreadcrumbsNav from "../../navigation/breadcrumbs-nav/BreadcrumbsNav";
import type { BreadcrumbItem } from "../../navigation/types/BreadcrumbItem";

const ScratchClubHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));

  const isPractice = location.pathname === "/scratch-club" || location.pathname === "/scratch-club/";
  const isRecord = location.pathname.includes("/scratch-club/record");

  const handleClick = (): void => {
        window.location.href = window.location.origin;
    };
  const breadcrumbItems: readonly BreadcrumbItem[] = [
    { label: isRecord ? 'Scratch Club - Record & Track' : 'Scratch Club - Practice' },
  ];

  return (
    <Box
          id={"mainBox"}
          sx={{
            // padding: isMobile ? "0 13px" :  "0 0",
            overflow: "hidden",
            margin: "0 auto",
            minHeight: "32px !important",
            marginBottom: "20px !important",
          }}
          className="maxWidthOverflow"
        >
    <Fragment>
        <Box className="coursesMargin" sx={{ marginTop: '40px', marginLeft: isMobile ? '15px' : '0' }}>
          <BreadcrumbsNav items={breadcrumbItems} separator="/" prefix="/" showIcon={true} />
        </Box>
      
      <Typography variant="h3" fontSize={30} fontWeight={{xs: 600, md: 700}} sx={{paddingLeft: { xs: "15px", md: "40px" }}} className={styles.title}>
        Scratch Club
      </Typography>
  
      <Box sx={{ px: { xs: 2, md: "14px" }, mt: "30px" }}>

        {/* Nav container */}
        <Box sx={{ position: "relative", width: "100%", maxWidth: 600 }}>
          {/* Tabs container with spacing */}
          <Grid container spacing={{xs: 1, sm: 2}} sx={{ justifyContent: "flex-start" }}>
            {[
              { label: "PRACTICE", active: isPractice, href: "/scratch-club" },
              { label: "RECORD & TRACK", active: isRecord, href: "/scratch-club/record" },
            ].map(({ label, active, href }) => (
              <Grid item xs="auto" key={label} sx={{ width: "auto" }}>
                <Box
                  onClick={() => navigate(href)}
                  sx={{
                    position: "relative",
                    textAlign: "center",
                    py: 1.5,
                    px: 3,
                    cursor: "pointer",
                    borderTop: "1px solid",
                    borderLeft: "1px solid",
                    borderRight: "1px solid",
                    borderBottom: "3px solid #FFFFFF !important",
                    borderColor: active ? "#7B726C" : "#D9D9D9",
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    bgcolor: active ? "transparent" : "#FAFAFA",
                    mb: active ? "-2px" : 0,
                    zIndex: active ? 1 : 0,
                    display: "inline-block",
                    minWidth: 265,
                    userSelect: "none",

                    "@media (max-width: 600px)": {
                      minWidth: 124,
                      // borderColor: "#D9D9D9"
                  },
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: 18,
                      fontWeight: active ? 700 : 500,
                      color: active ? "#1D1A1A" : "#979797",
                      whiteSpace: "nowrap",
                      fontFamily: "'Repro', sans-serif",
                      letterSpacing: '-1px',

                      // "@media (max-width: 600px)": {
                      //     color: active ? "#000000" : "#979797"
                      // }
                    }}
                  >
                    {label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* the line bellow links*/}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              height: "1px",             
              bgcolor: "#7B726C",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              width: "calc(98vw - 40px)",
              maxWidth: "none",
              zIndex: 0,
            }}
          />
        </Box>
      </Box>
    </Fragment>
    </Box>
  );
};

export default ScratchClubHeader;
